<template>
    <div>
        <template v-if="crud_department === true">
            <div class="container">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left">Add Department</h1>
                </div>
                <div class="global-main">
                    <form id="DepartmentForm" @submit.prevent="addDepartmentData">
                        <div class="tab-content-inner">
                            <div class="form-group">
                                <label> Name </label>
                                <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                <has-error :form="form" field="name"></has-error>
                            </div>
                        </div>
                        <div class="form-group">
                            <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                            <router-link to="/departments" class="btn btn-primary float-right mr-2">Cancel</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-if="crud_department === null"><preLoader></preLoader></template>
        <template v-if="crud_department === false"><notAllowed></notAllowed></template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    name : '',
                }),
                crud_department: null,
            }
        },
        mounted() {
            this.can('crud_department').then(result=>{
                this.crud_department = result.crud_department;
            });
        },
        methods: {
            addDepartmentData() {
                this.$Progress.start();
                this.form.post('api/addDepartment')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Department created successfully');
                        this.$router.push('/departments');
                    }else{
                        this.$Progress.fail();
                    }

                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            }
        }
    }
</script>
